import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getSrtSecrets = createAsyncThunk("srtSecrets/getSrtSecrets", async (payload) => {
  try {
    const response = await magnifiAPI.getSrtSecrets(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const processSrtSecretKey = createAsyncThunk("srtSecrets/createSrtSecret", async (payload) => {
  try {
    const response = await magnifiAPI.processSrtSecretKey({ ...payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
